<script lang="ts" setup>
definePageMeta({
  layout: 'strapi',
})
</script>

<template>
  <CommonStrapiPreview />
</template>
